import _ from 'lodash';

import locationRes from '../resources/location.resource';
import Selector, {selectorTpl, REQUIRED_IMPORTS} from './selector/selector.component';


class LocationSelectorComponent extends Selector {
  constructor(LocationResource, $timeout, gettextCatalog) {
    super(gettextCatalog.getString('Toimipaikka'));

    this.LocationResource = LocationResource;

    /**
     * Location set by the parent component.
     * @type {Location}
     */
    this.location = null;

    /**
     * Callback to call when object is selected.
     * @type {Function}
     */
    this.selectCallback = null;

    /**
     * An initial value for locations, just Id.
     * @type {?Number}
     */
    this.initialId = null;

    /**
     * List of allowed location ids.
     * @type {?Array.<Number>}
     */
    this.idFilter = null;

    this.loaded = false;

    this.$timeout = $timeout;
  }

  loadData() {
    return this.LocationResource.getAll().then(locations => {
      const locs = locations.list
      .filter(loc => this.idFilter == null || this.idFilter.includes(loc.id))
      .map(loc => {
        return { label: loc.name, obj: loc };
      });

      return _.sortBy(locs, ['label']);
    });
  }

  $onInit() {
    this.object = this.location;
    super.$onInit();
  }

  $onChanges() {
    this.object = this.location == null? null : this.objs.find(loc => loc.obj.id === this.location.id);
    super.$onChanges();
  }

  onPostInit() {
    if (this.location == null && this.initialId != null) {
      this.object = this.objs.find(loc => loc.obj != null && loc.obj.id === this.initialId);
    }
    this._setObject();
    this.loaded = true;
    this.$timeout(() => this.selectCallback({location: this.object}));
  }

  onSelect() {
    super.onSelect();
    this.selectCallback({location: this.object});
  }
}

const config = {
  templateUrl: selectorTpl,
  controller: LocationSelectorComponent,
  bindings: {
    location: '<',
    initialId: '<?',
    idFilter: '<?',
    selectCallback: '&',
    extraClasses: '@?'
  }
};

const mod = angular.module('app.component.locationSelector', _.union(REQUIRED_IMPORTS, [locationRes]))

.component('locationSelector', config)

;

export default mod.name;
